(function () {
  'use strict';

  angular
    .module('payrollDutySummary')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('payrollDutySummary', {
        url: '/payrollDutySummary',
        views: {
        	'payrollDutySummaryView' : {
        		templateUrl: 'payroll-duty-summary/views/payroll-duty-summary.tpl.html',
                controller: 'PayrollDutySummaryCtrl',
                controllerAs: 'payrollDutySummary'
        	}
        }
      });
  }
}());
